const buildingsApi = {
  buildings: {
    list: '/api/buildings',
  },
};

export default buildingsApi;

export const buildingsApiConfig = buildingsApi.buildings;
